export const abbreviateLastName = (name: string): string => {
    const parts = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (parts.length < 2) {
        return parts[0] || '';
    }

    const last = parts[parts.length - 1];
    if (/^[A-Za-z]\.?$/.test(last)) {
        return parts.join(' ');
    }

    const initial = last.replace(/[^A-Za-z]/g, '').charAt(0);
    if (!initial) {
        return parts.join(' ');
    }

    return `${parts.slice(0, -1).join(' ')} ${initial.toUpperCase()}.`;
};
